import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { HowToPlayPage } from "@/components/HowToPlayPage";
import { megaMillionsHowToPlayData } from "@/data/how-to-play-mega-millions";
import { buildFaqJsonLd } from "@/lib/faq-jsonld";

export const Route = createFileRoute("/mega-millions/how-to-play")({
  head: () => buildSeo({
    title: "How to Play Mega Millions: Rules & Prizes | USA Lottery Club",
    description: megaMillionsHowToPlayData.meta.description,
    path: "/mega-millions/how-to-play",
    type: "article",
    jsonLd: buildFaqJsonLd(megaMillionsHowToPlayData),
  }),
  component: () => <HowToPlayPage {...megaMillionsHowToPlayData} />,
});
